module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921042651_T.08765666.jpg";